import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";

import Row from "../../../common/layout/row";
import LabelAndInput from "../../../common/form/LabelAndInput";
import LabelAndSelect from "../../../common/form/LabelAndSelect";
import Table from "../../../common/layout/Table";
import Grid from "../../../common/layout/grid";
import { formatUtcAsLocal, localInputHoursFromNow, toApiUtc } from "../utils/datetime";

class CrashResults extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: this.props.userId,
      resultsStart: localInputHoursFromNow(-5),
      resultsEnd: localInputHoursFromNow(24),
      users: [],
      crashResults: [],
      resultsAutoRefresh: true,
    };
  }

  intervalId = null;
  loadedOnce = false;

  componentDidMount() {
    this.getUsers();
    this.intervalId = setInterval(this.tick, 10000);
    this.resultsTabLink = document.querySelector('a[href="#menu5"]');
    if (this.resultsTabLink) {
      // click nativo: Bootstrap/jQuery nem sempre propaga shown.bs.tab para addEventListener.
      this.resultsTabLink.addEventListener("click", this.onResultsTabClick);
    }
    if (typeof window !== "undefined" && window.$) {
      window.$(document).on("shown.bs.tab.crashResults", 'a[href="#menu5"]', this.onResultsTabShown);
    }
    this.tick(true);
  }

  componentWillUnmount() {
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.resultsTabLink) {
      this.resultsTabLink.removeEventListener("click", this.onResultsTabClick);
    }
    if (typeof window !== "undefined" && window.$) {
      window.$(document).off("shown.bs.tab.crashResults", 'a[href="#menu5"]', this.onResultsTabShown);
    }
  }

  isResultsTabActive = () => {
    const pane = document.getElementById("menu5");
    return !!(pane && pane.classList.contains("active"));
  };

  onResultsTabShown = () => {
    this.loadData();
  };

  onResultsTabClick = () => {
    // Aguarda Bootstrap marcar #menu5 como active.
    setTimeout(() => {
      if (this.isResultsTabActive()) this.loadData();
    }, 50);
  };

  tick = (force = false) => {
    if (!this.isResultsTabActive()) return;
    if (!this.state.resultsAutoRefresh && !force && this.loadedOnce) return;
    this.loadData();
  };

  dateWindow = (startDate, endDate) => ({
    start: toApiUtc(startDate),
    end: toApiUtc(endDate),
  });

  loadData = (userId = this.state.userId, startDate = this.state.resultsStart, endDate = this.state.resultsEnd) => {
    const { start, end } = this.dateWindow(startDate, endDate);
    const canFilterUser = this.canSelectUsers();
    if (canFilterUser && userId == null) return;

    const search = canFilterUser
      ? `search=user_id:${userId};created_at:${start};created_at:${end}&searchFields=user_id:=;created_at:>;created_at:<`
      : `search=created_at:${start};created_at:${end}&searchFields=created_at:>;created_at:<`;

    axios
      .get(
        `${process.env.REACT_APP_API_HOST}/crash_results?${search}&orderBy=id&sortedBy=desc&limit=200`,
        { silent: true }
      )
      .then((resp) => {
        this.loadedOnce = true;
        this.setState({ crashResults: resp.data.data || [] });
      })
      .catch((e) => {
        // Não limpa a lista nem spamma toastr em erro de rede transitório.
        console.warn("CrashResults loadData falhou", e && e.message);
      });
  };

  canSelectUsers = () => !!(this.props.scopes && this.props.scopes.users);

  getUsers = () => {
    if (!this.canSelectUsers()) return;
    axios
      .get(`${process.env.REACT_APP_API_HOST}/users`, { silent: true })
      .then((resp) => {
        this.setState({ users: resp.data.data });
      })
      .catch((e) => {
        console.warn("CrashResults getUsers falhou", e && e.message);
      });
  };

  render() {
    const canSelectUsers = this.canSelectUsers();
    return (
      <>
        <Row cols='12 3 3'>
          {canSelectUsers && (
            <LabelAndSelect
              label='Usuário'
              name='selectUser'
              readOnly={false}
              forceToShow={true}
              cols='12 3 3'
              options={this.state.users}
              input={{
                value: this.state.userId,
                onChange: (value) => {
                  const userId = value == null || value === "" ? null : Number.parseInt(value, 10);
                  this.setState({ userId }, () => this.loadData());
                },
              }}
            />
          )}
          <LabelAndInput
            label='Início'
            name='resultsStart'
            type='datetime-local'
            readOnly={false}
            forceToShow={true}
            cols='12 3 3'
            input={{
              value: this.state.resultsStart,
              onChange: (e) => this.setState({ resultsStart: e.target.value }, () => this.loadData()),
            }}
          />
          <LabelAndInput
            label='Fim'
            name='resultsEnd'
            type='datetime-local'
            readOnly={false}
            forceToShow={true}
            cols='12 3 3'
            input={{
              value: this.state.resultsEnd,
              onChange: (e) => this.setState({ resultsEnd: e.target.value }, () => this.loadData()),
            }}
          />
          <LabelAndInput
            label='Auto Refresh'
            name='resultsAutoRefresh'
            type='checkbox'
            readOnly={false}
            forceToShow={true}
            cols='12 3 3'
            input={{
              checked: this.state.resultsAutoRefresh,
              onChange: (e) => this.setState({ resultsAutoRefresh: e.target.checked }),
            }}
          />
        </Row>
        <Row>
          <Grid cols='12 12 12'>
            <Table
              title='RESULTADOS'
              cols='12 12 12'
              body={this.state.crashResults}
              labelMobile='RESULTADOS'
              attributes={{
                created_at: {
                  title: "Horário",
                  callback: (val) => formatUtcAsLocal(val),
                },
                value: {
                  title: "Crash",
                  callback: (val) => (val != null ? Number(val).toFixed(2) + "x" : "---"),
                },
                players: "Jogadores",
                original_id: "ID",
              }}
            />
          </Grid>
        </Row>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userId: state.auth.user.id,
  scopes: (state.auth.profile && state.auth.profile.scopes) || {},
});

export default connect(mapStateToProps)(CrashResults);
